module.exports = __webpack_public_path__ + "img/2.40f52a5e.png";